import React from 'react';
import {t} from 'i18next';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';
import {ReactComponent as InfoIcon} from '../../../../../assests/svg/info_icon.svg';
import AurTooltip from '../../../../common/aur-tooltip/AurTooltip';
import {
  ProcessingSummaryReportType,
  ProcessingSummaryTypeMapToCaption,
} from '../ProcessingSummaryTab';
import {numberFormatter} from '../../../../../utils/utils';

interface DataTableProps {
  data: ProcessingSummaryReportType;
}

const DataTable: React.FC<DataTableProps> = ({data}) => {
  return (
    <TableContainer component={Paper} className="data-table" tabIndex={0}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <div className="header-content">
                <Typography className="typo-text label1_size custom-head-text">
                  {t(`reports.processingHistoryChart.type`)}
                </Typography>
              </div>
            </TableCell>
            <TableCell>
              <div className="header-content">
                <div className="column-separator"></div>
                <Typography className="typo-text label1_size custom-head-text">
                  {t(`reports.processingHistoryChart.fileCount`)}
                </Typography>
              </div>
            </TableCell>
            <TableCell align="left" className="header-cell">
              <div className="header-content">
                <div className="column-separator"></div>
                <Typography className="typo-text label1_size custom-head-text">
                  {t(`reports.processingHistoryChart.totalSize`)}
                </Typography>
              </div>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.processingSummary.map((row, index) => (
            <TableRow key={index}>
              <TableCell>
                <div className="table-type-cell">
                  <Typography className="typo-text body3_size custom-row-text">
                    {t(
                      `reports.processingSummary.${ProcessingSummaryTypeMapToCaption[row.type]}`
                    )}
                  </Typography>
                  <AurTooltip
                    title={t(
                      'reports.processingHistoryChart.dataTable.toolTip.' +
                        ProcessingSummaryTypeMapToCaption[row.type]
                    )}
                  >
                    <InfoIcon />
                  </AurTooltip>
                </div>
              </TableCell>
              <TableCell align="left">
                <Typography className="typo-text body3_size custom-row-text">
                  {row.fileCount === 0 ? '--' : numberFormatter(row.fileCount)}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography className="typo-text body3_size custom-row-text">
                  {numberFormatter(row.totalSize, {maximumFractionDigits: 2})}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DataTable;
